import React from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Editor as EditorType } from "tinymce";
import { TemplateEditorInput } from "./types";
import { ToolbarType } from "./enum";

const premiumPlugins =
  "advlist advcode autolink lists link image charmap preview anchor searchreplace visualblocks fullscreen media table help";
export const ToolbarVariation = {
  [ToolbarType.BASIC]: "undo redo link  | bold italic underline",
  [ToolbarType.FULL]:
    "undo redo code link | formatselect | bold italic underline backcolor forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help"
};

function TemplateEditor({
  value,
  handleEditorChange,
  toolbarType,
  height,
  onBlur,
  disabled,
  placeholder,
  removeInitialPTag = false
}: TemplateEditorInput) {
  const [initialValue] = React.useState(() => value);
  const onEditorChange = React.useCallback(
    (v: string, editor: EditorType) => {
      if (removeInitialPTag) {
        handleEditorChange(v.replace(/^<p>/, "").replace(/<\/p>$/, ""), editor);
        return;
      }
      handleEditorChange(v, editor);
    },
    [handleEditorChange, removeInitialPTag]
  );

  return (
    <Editor
      tinymceScriptSrc="/tinymce/tinymce.min.js"
      initialValue={initialValue}
      init={{
        height,
        menubar: false,
        plugins: premiumPlugins,
        toolbar: ToolbarVariation[toolbarType],
        entity_encoding: "raw",
        placeholder,
        content_style: "body{margin: 0px 16px;padding: 0px;font-size:13px;}",
        formats: {
          bold: { inline: "b", exact: true },
          italic: { inline: "i", exact: true },
          underline: { inline: "u", exact: true }
        },
        extended_valid_elements: "i[*],em,b[*],strong",
        paste_as_text: true
      }}
      onBlur={onBlur}
      onPaste={onBlur}
      onEditorChange={onEditorChange}
      disabled={disabled}
    />
  );
}

export default TemplateEditor;
